import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from '../../config/config';

@Injectable({
    providedIn: 'root'
})
export class MunicipioService {

    private _config: Config = new Config();

    constructor(private http: HttpClient) { }

    public listarMuncipiosEmpresas (filtros: any = null, page: number|string = 1, perPage: number|string = 5): Observable<any> {
        const request = {
            filtros: filtros,
            page: page,
            perPage: perPage,
        };
        return this.http.post<any>(`${this._config.get('urlServiceBackend')}municipio/listar`,
        JSON.stringify(request), { headers: { 'Content-Type': 'application/json' }});
    }

    public inserirMunicipiosEmpresa(filtros: any) {
        return this.http.post<any>(`${this._config.get('urlServiceBackend')}municipio/inserir`,
        JSON.stringify(filtros), { headers: { 'Content-Type': 'application/json' }});
    }

    /**
     *
     * @param id_empresa
     * @param id_municipio
     */
    public removeMunicipiosMapeados(empresa: String, id_municipio: Number): Observable<any> {
        return this.http.post<any>(`${this._config.get('urlServiceBackend')}municipio/removermunicipiosvinculados`,{'empresa': empresa, 'id_municipio': id_municipio});
    }
}
